type DatapointStruct = {
  __value_source?: unknown;
  [key: string]: unknown;
};

export const isMemoryValueSource = (struct: unknown): boolean => {
  if (!struct || typeof struct !== 'object') {
    return false;
  }
  return (struct as DatapointStruct).__value_source === 'memory';
};
